// Địa chỉ backend DUY NHẤT của app. Mọi file khác import API_BASE_URL từ đây.
// Có thể ghi đè bằng biến REACT_APP_API_URL (vd http://localhost:8000 khi chạy dev).
export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://api.aidicho.com').replace(/\/+$/, '');
